import { render } from "./table-action-export.vue?vue&type=template&id=b837d52c"
import script from "./table-action-export.vue?vue&type=script&lang=js"
export * from "./table-action-export.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__